import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { EnvironmentService } from '../../environment.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss',
})
export class FileUploadComponent implements OnInit{
  @Output() fileData = new EventEmitter<any>();
  @Output() fileDelete = new EventEmitter<any>();
  @Input() height: any;
  @Input() width: any;
  @Input() fileAreaHeight: any;
  @Input() fileAreaWidth: any;
  @Input() showFileDetails: boolean = true;
  @Input() imageId: string;
  constructor(private _formBuilder: FormBuilder,private http: HttpClient, private envService: EnvironmentService) {}
  ngOnInit(): void {
    if(this.imageId){
      this.apiImgAvlbl = true
      this.uploadProgress = 100
      this.fileSizeError = false
      this.fileTypeError = false
      this.setImageFromApi(this.imageId)
    }
  }
  uploadIconForm = this._formBuilder.group({
    file: ['', Validators.required],
  });
  fileUploading: boolean = false;
  uploadProgress: number | null = null;
  selectedFile: any;
  selectedFileName: string = '';
  selectedFileSize: number = 0;
  fileSizeError: boolean = false;
  fileSizeErrorMessage: string = '';
  fileTypeError: boolean = false;
  fileSizeInKb: number = 0;
  selectedFileUrl: any;
  fileAction: string;
  apiImgAvlbl:boolean = false
  onDragOver(event: DragEvent): void {
    event.preventDefault(); // Prevent default to allow drop
    // You can add visual feedback here for drag over
  }

  onDrop(event: DragEvent): void {
    this.onFileChange(event, 'drag'); // Use the same method to handle drop
    // Check if files are available
    if (event.dataTransfer?.files && event.dataTransfer?.files.length > 0) {
      // Handle the files (e.g., update the file input)
      this.handleFileSelect(event.dataTransfer?.files);
    }
  }

  handleFileSelect(files: FileList) {
    const inputElement = document.getElementById('file') as HTMLInputElement;
    // Create a DataTransfer to set files in the input
    const dataTransfer = new DataTransfer();
    for (let i = 0; i < files.length; i++) {
      dataTransfer.items.add(files[i]);
    }
    // Set the input element's files property
    inputElement.files = dataTransfer.files;

    // Optionally trigger a change event
    const changeEvent = new Event('change', { bubbles: true });
    inputElement.dispatchEvent(changeEvent);
  }

  // Unified file change handler for both click and drag-and-drop
  onFileChange(event: any, action: 'upload' | 'drag'): void {
    let file: File | null = null;
    this.fileAction = action;
    this.uploadProgress = 0
    // Handle drag-and-drop event
    if (action === 'drag' && event instanceof DragEvent) {
      event.preventDefault(); // Prevent default behaviors
      if (event.dataTransfer) {
        file = event.dataTransfer.files[0]; // Get the first file
      }
    }
    // Handle file input change event
    else if (action === 'upload' && event.target instanceof HTMLInputElement) {
      file = (event.target as HTMLInputElement).files?.[0] || null; // Get the first file
    }
    // Construct response if a file is present
    if (file) {
      this.selectedFileName = file.name;
      this.selectedFileSize = file.size;
      const allowedTypes = [
        'image/webp',
        'image/png',
        'image/jpg',
        'image/jpeg'
      ];
      this.fileTypeError = !allowedTypes.includes(file.type);
      this.fileSizeInKb = this.convertBytesToKB(this.selectedFileSize);
      if (this.validateFileSize(this.selectedFileSize)) {
        this.fileSizeError = false;
      } else {
        this.fileSizeErrorMessage = 'File size should be 50 KB or less.';
        this.fileSizeError = true;
      }
      if(this.imageId){
        this.fileSizeError = false
        this.fileTypeError = false
        this.uploadProgress = 100
      }
      const response = {
        file: {
          name: file.name,
          size: file.size,
          type: file.type,
          lastModified: file.lastModified,
        },
        event: this.extractEventDetails(event),
        fileAction: action,
      };

      this.selectedFile = response;
      this.handleFiles(this.selectedFileSize);
      // Further upload logic can be handled here
    } else {
      console.warn('No files were selected or dragged.');
    }
  }

  // Extract relevant event details for logging
  private extractEventDetails(event: Event | DragEvent) {
    return {
      isTrusted: event.isTrusted,
      bubbles: event.bubbles,
      cancelBubble: event.cancelBubble,
      cancelable: event.cancelable,
      composed: event.composed,
      currentTarget: event.currentTarget,
      defaultPrevented: event.defaultPrevented,
      eventPhase: event.eventPhase,
      returnValue: event.returnValue,
      srcElement: event.srcElement,
      target: event.target,
      timeStamp: event.timeStamp,
      type: event.type,
    };
  }


  setImageFromApi(imageId: string): void {
    const fileDownloadUrl = `${this.envService.imgReviewUrl}/${imageId}`;

    // Make HTTP request to fetch image data as Blob
    this.http.get(fileDownloadUrl, { responseType: 'blob' }).subscribe(blob => {
      // Create a File object from the Blob
      const file = new File([blob], `${imageId}.jpg`, { type: blob.type });

      // Get the input element by ID
      const fileInput = document.getElementById('file') as HTMLInputElement;

      if (fileInput) {
        // Create a new DataTransfer object
        const dataTransfer = new DataTransfer();
        // Add the file to the DataTransfer object
        dataTransfer.items.add(file);
        // Set the input element's files property
        fileInput.files = dataTransfer.files;

        // Trigger the change event manually to reflect the selected file
        const event = new Event('change', { bubbles: true });
        fileInput.dispatchEvent(event);
      }
    }, 
    (error: HttpErrorResponse) => {
      if(error.status === 404){
        this.fileUploading = false 
        this.fileSizeError = false
        this.apiImgAvlbl = false
        this.fileTypeError = false
        // this.uploadProgress = null
      }
    });
  }

  validateFileSize(size: number): boolean {
    const sizeInKB = size / 1024;
    return sizeInKB <= 50; // File size limit of 50KB
  }

  convertBytesToKB(bytes: number): number {
    return Number((bytes / 1024).toFixed(2)); // Convert bytes to KB and round to two decimal places
  }

  private handleFiles(fileSize: any) {
    this.fileUploading = true;
    const totalSize = fileSize;
    const uploadSpeed = 100000; // Simulate upload speed in bytes per interval
    let interval = setInterval(() => {
      if (this.uploadProgress !== null) {
        const uploaded = (this.uploadProgress / 100) * totalSize;
        const newUploaded = uploaded + uploadSpeed;
        const newProgress = Math.min(100, (newUploaded / totalSize) * 100);

        this.uploadProgress = Math.round(newProgress);
        if (this.uploadProgress >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            this.uploadProgress = null; // Reset after showing 100% for a while
            if (this.fileSizeError === false && this.fileTypeError === false) {
              this.fileData.emit({
                file: this.selectedFile,
                fileAction: this.fileAction,
              });
            } else {
              this.fileData.emit({
                file: 'error',
                fileAction: this.fileAction,
              });
            }
          }, 500);
        }
      }
    }, 100);
  }

  retryFileUpload() {
    this.fileUploading = false;
    this.fileSizeError = false;
    this.fileTypeError = false
    this.selectedFile = null;
  }

  deleteUploadedFile() {
    this.selectedFileName = '';
    this.fileSizeInKb = 0;
    this.fileUploading = false;
    this.fileSizeError = false;
    this.fileTypeError = false
    this.fileDelete.emit(true);
  }

  viewFile() {
    if (this.selectedFile) {
      const fileURL = URL.createObjectURL(this.selectedFile?.event?.target?.files[0]);
      window.open(fileURL, '_blank');
    }
  }
}
